
import * as defaultImport from "@splunk/react-icons/ArrowTriangleDown";
export * from "@splunk/react-icons/ArrowTriangleDown";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
